import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { requestDestination } from '../actions/destination';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';

import ServiceSiteList from '../components/servicesite/ServiceSiteList';
import Instructions from '../components/instructions/Instructions';

class Destination extends React.Component {
  componentWillMount() {
    const { requestDestination, destinationId, destination } = this.props;

    if (this.updateNavbar(destination)) {
      requestDestination(destinationId);
    }
  }

  componentWillReceiveProps(props) {
    const { destination: currentDestination } = this.props;
    const { destination } = props;

    this.updateNavbar(destination, currentDestination);
  }

  updateNavbar(destination, currentDestination) {
    const { enableSubNavbar, setSubNavbar } = this.props;

    const { id, companyName, streetAddress, city, isPartial } = destination;

    if (currentDestination !== undefined && id === currentDestination.id) {
      return false;
    }

    if (!id) {
      enableSubNavbar();
      return true;
    }

    const urlPathParts = window.location.href.split("/");
    const sourcePath = urlPathParts[urlPathParts.length - 1];
    setSubNavbar({
      title: [
        companyName,
        `${streetAddress}, ${city}`,
      ],
      backLink: (sourcePath === "frontpage" ? "/" : "/deviations"),
    });

    return isPartial;
  }

  render() {
    const { destination = {}, translate } = this.props;
    const { id, serviceSites, instructions } = destination;

    let serviceSitesComponent;

    if (serviceSites && serviceSites.length === 0) {
      serviceSitesComponent = (
        <h4>{translate('destination_no_service_sites')}</h4>
      );
    } else {
      serviceSitesComponent = (
        <ServiceSiteList additionalInfo={true} serviceSites={(serviceSites || []).map(serviceSite => ({
          ...serviceSite,
          link: `/servicesite/${id}/${serviceSite.id}`,
        }))} />
      );
    }

    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="visible-xs-block">
              <Instructions destination={destination} />
            </div>
            <div className="col-sm-6">
              <h1>{translate('service_site.plural')}</h1>
              {serviceSitesComponent}
            </div>
            {!!instructions &&
              <div className="col-sm-6">
                <Instructions className="hidden-xs" destination={destination} instructions={instructions} />
                <Instructions className="visible-xs-block" instructions={instructions} />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const destinationId = ownProps.match.params.destinationId;

  return {
    destinationId,
    destination: state.destination.destinationMap[destinationId] || {},

    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
  requestDestination,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Destination);



// WEBPACK FOOTER //
// ./src/views/Destination.js